module.exports = __webpack_public_path__ + "static/media/end_object_after.5e256adf.png";